const getSVG = function (svgUrl, logger) {
  const options = {
    method: 'GET',
    credentials: 'same-origin'
  }

  return fetch(svgUrl, options)
    .then(function (response) {
      logger.log('processing spritesheet response')
      return response.text()
    })
    .then(function (svg) {
      logger.log('removing XML doctype')
      return svg.replace('<?xml version="1.0" encoding="utf-8"?>', '')
    })
}

export default {
  getSVG
}
